import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableClaimsView.
 * @extends JetView
 */
export default class tableClaimsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Main view type
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scroll: true, // Enable scrolling
            columns: [
                // Column definitions for the datatable
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    template: function (obj) {
                        // Template for rendering the column
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'DateTimeCreation', // DateTimeCreation column ID
                    header: _('Fecha/Hora Creación'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Year', header: _('Año'), width: 100, sort: 'int' }, // Year column
                {
                    id: 'Diligence', // Diligence column ID
                    header: _('Diligenciado'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'UserId', // UserId column ID
                    header: _('ID Usuario'), // Localized header
                    width: 150, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Name', header: _('Nombres'), width: 150, sort: 'int' }, // Name column
                { id: 'Email', header: _('Email'), width: 250, sort: 'int' }, // Email column
                { id: 'Phone', header: _('Teléfono'), width: 100, sort: 'int' }, // Phone column
                { id: 'Type', header: _('Type'), width: 100, sort: 'int' }, // Type column
                {
                    id: 'Message', // Message column ID
                    header: _('Mensaje'), // Localized header
                    width: 400, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Handler for details icon click
                    var item = this.getItem(id); // Get the clicked item
                    var obj = JSON.parse(item.Message); // Parse the Message field
                    $$('data').parse(obj); // Populate the data view with parsed object
                    $$('detailClaim').show(); // Show the detail claim popup
                },
                info: function (euv, id) {
                    // Handler for info icon click
                    this.$scope.app.callEvent('popupInfo:button', [[]]); // Trigger popup info event
                },
            },
            footer: false, // Disable footer
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Fetch configuration from devConfig
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var vthis = this; // Preserve context
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable instance
        var url = devConfig.geturlApi() + 'Report/GetGenericForms'; // API endpoint for fetching data
        var filter = ''; // Filter string for API requests
        var i = ''; // Temporary variable
        var popup = webix.ui({
            // Create detail claim popup
            view: 'window', // Popup view type
            id: 'detailClaim', // Unique identifier for the popup
            width: screen.width < 500 ? 350 : 550, // Width based on screen size
            height: screen.width < 500 ? 600 : 400, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration for the popup
                view: 'toolbar', // Toolbar view type
                cols: [
                    // Columns in the toolbar
                    { view: 'label', label: _('Detalles') }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close popup on click
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Modal popup
            body: {
                // Body configuration for the popup
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'template', // Template view for displaying data
                    id: 'data', // Unique identifier for the template
                    height: 350, // Height of the template
                    css: 'movies', // CSS class for styling
                    scroll: 'y', // Vertical scrolling
                    template: function (obj) {
                        // Template function for rendering data
                        var string = ''; // Initialize string for concatenation
                        $.each(obj, function (index, value) {
                            // Iterate over object properties
                            vthis.i =
                                "<div class='overall'><div class='title title_form'>" +
                                index +
                                "</div><div class='value'>" +
                                value +
                                '</div> </div>'; // Create HTML for each property
                            string = string.concat(' ', vthis.i); // Concatenate to the string
                        });
                        return string; // Return the final HTML string
                    },
                },
            },
        });
        this.on(this.app, 'managementContact:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append to filter string
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object type
                        if (object[i][0] === 'Year') {
                            // Special handling for Year
                            var d = new Date(object[i][1]); // Create date object
                            var dateFrom = 'Year=' + d.getFullYear(); // Extract year
                            string1 = string1 + '&' + dateFrom; // Append to filter string
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data based on selected player ID
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event listener for item double-click
            var item = this.getItem(id); // Get clicked item
            var obj = JSON.parse(item.Message); // Parse the Message field
            $$('data').parse(obj); // Populate the data view with parsed object
            popup.show(); // Show the detail claim popup
        });
        var popupInfo = webix.ui({
            // Create info popup
            view: 'window', // Popup view type
            id: 'infoWindow', // Unique identifier for the popup
            width: 550, // Width of the popup
            height: 450, // Height of the popup
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration for the popup
                view: 'toolbar', // Toolbar view type
                cols: [
                    // Columns in the toolbar
                    { view: 'label', label: _('Información') }, // Title label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close popup on click
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Modal popup
            body: {
                // Body configuration for the popup
                view: 'scrollview', // Scrollable view
                scroll: 'xy', // Horizontal and vertical scrolling
                body: {
                    view: 'form', // Form view for displaying information
                    id: 'infoForm', // Unique identifier for the form
                    elements: [
                        // Form elements
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Columns in the form
                                {
                                    view: 'text', // Text input for ID
                                    labelPosition: 'top', // Label position
                                    label: _('Id'), // Localized label
                                    name: 'Id', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for Type
                                    labelPosition: 'top', // Label position
                                    label: _('Type'), // Localized label
                                    name: 'Type', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for DateTimeCreation
                                    labelPosition: 'top', // Label position
                                    label: _('Fecha/Hora Creación'), // Localized label
                                    name: 'DateTimeCreation', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Columns in the form
                                {
                                    view: 'text', // Text input for UserId
                                    labelPosition: 'top', // Label position
                                    label: _('ID Usuario'), // Localized label
                                    name: 'UserId', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for Name
                                    labelPosition: 'top', // Label position
                                    label: _('Nombres'), // Localized label
                                    name: 'Name', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                                {
                                    view: 'text', // Text input for Email
                                    labelPosition: 'top', // Label position
                                    label: _('Email'), // Localized label
                                    name: 'Email', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Columns in the form
                                {
                                    view: 'text', // Text input for Phone
                                    labelPosition: 'top', // Label position
                                    label: _('Teléfono'), // Localized label
                                    name: 'Phone', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                },
                            ],
                        },
                        {
                            margin: 10, // Margin for the element
                            cols: [
                                // Columns in the form
                                {
                                    view: 'textarea', // Textarea for Message
                                    labelPosition: 'top', // Label position
                                    label: _('Mensaje'), // Localized label
                                    name: 'Message', // Input name
                                    readonly: true, // Read-only input
                                    minWidth: 220, // Minimum width
                                    height: 150, // Height of the textarea
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'popupInfo:button', (filter) => {
            // Event listener for showing info popup
            popupInfo.show(); // Show the info popup
            $$('infoForm').bind($$('datatable')); // Bind the form to the datatable
        });
    }
}

// FILE DOCUMENTED
